/**
 * "0900" → 540 (分換算)
 */
const hmToMinutes = (hm: string): number => {
  const h = parseInt(hm.substring(0, 2), 10);
  const m = parseInt(hm.substring(2, 4), 10);
  return h * 60 + m;
};

/**
 * 営業時間と所要時間から30分刻みの予約開始時刻候補を生成する
 *
 * @param startHm 営業開始時刻 (例: "0900")
 * @param endHm   営業終了時刻 (例: "1900")
 * @param workingMinutes 所要時間（分）
 * @returns 開始時刻ラベル一覧
 */
export const generateCoatingTimeSlots = (
  startHm: string | null | undefined,
  endHm: string | null | undefined,
  workingMinutes: number,
): { label: string; value: number }[] => {
  if (!startHm || !endHm || workingMinutes <= 0) {
    return [];
  }
  const startTotal = hmToMinutes(startHm);
  const endTotal = hmToMinutes(endHm);
  if (Number.isNaN(startTotal) || Number.isNaN(endTotal)) {
    return [];
  }

  const slots: { label: string; value: number }[] = [];
  for (let t = startTotal; t + workingMinutes <= endTotal; t += 30) {
    const h = Math.floor(t / 60);
    const m = t % 60;
    const label = `${h}:${m.toString().padStart(2, '0')}`;
    slots.push({ label, value: slots.length });
  }
  return slots;
};
